import urls from "../../../../global/constants/UrlConstants";
import { getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function login(email: string, password: string) {
  const body = {
    email: email,
    username: password,
  };
  try {
    const callParams = getNoAuthCallParams("POST", body);
    const response = await makeCall(urls.login, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export const patternCheckForMobile = (input: string) => {
  var mobileNumberPatter = /^\d+(\.\d+)?$/;
  return mobileNumberPatter.test(input);
};
